var map = {
	"./en/fields.json": 7090,
	"./en/seo.json": 2004,
	"./en/validations.json": 4357,
	"./en/web.json": 7007,
	"./es/fields.json": 1295,
	"./es/seo.json": 9119,
	"./es/validations.json": 7186,
	"./es/web.json": 3484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9628;